import { httpRequest } from "@services/http";

export class CommandDeleteApprovedUrl {
  async run(organizationId: number, approvedUrlId: number): Promise<string> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/approved-urls/${approvedUrlId}/`;
    return await httpRequest<string>(url, { method: "DELETE" });
  }
}
